import { i18n_t as $t } from '@/utils/i18n';

export const getDefaultSelectedChannel = () => ({
    id: 'inAppPlusEmail',
    label: $t('globalFilters.In_app + Email'),
});

export const getDefaultSelectedApp = () => {
    return {
        id: '*',
        displayName: $t('globalFilters.All Apps'),
    };
};

// This is deprecated. For internationalization purposes, use getDefaultSelectedApp instead.
export const defaultSelectedApp = getDefaultSelectedApp();

export const defaultSelectedFeatureType = {
    id: 1,
    label: $t('globalFilters.All Types'),
};

export const defaultSelectedAccount = {
    id: '',
    text: $t('globalFilters.All Accounts'),
    className: 'account-chooser-all-accounts',
};
